import React, {useEffect} from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { useAuth } from 'app/ProviderAuth';
import { GraphCard } from './components';
import { queryApplications, queryReferrers, getMessages } from 'apis';
import CircularProgress from '@mui/material/CircularProgress';
import { Timestamp } from 'firebase/firestore';
const LoadingIndicator: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress />
    </Box>
  );
};
export const AdminHomePage = () => {
  const { isLoading: userIsLoading, isAdmin } = useAuth();
  const [applicationData, setApplicationData] = React.useState<Timestamp[]>([]);
  const [referrerData, setReferrerData] = React.useState<Timestamp[]>([]);
  const [messageData, setMessageData] = React.useState<Timestamp[]>([]);
  const [messageUserData, setMessageUserData] = React.useState<Timestamp[]>([]);
  const [dataLoading, setDataLoading] = React.useState(true);
  useEffect(() => {
    if (!userIsLoading && isAdmin) {
      const fetchData = async () => {
        setDataLoading(true);
        const [
          referrersSnapshot,
          applicationsSnapshot,
          messages
        ] = await Promise.all([
          queryReferrers(),
          queryApplications("createdAt", "desc"),
          getMessages()
        ]);
        const referrerCreateAtList = referrersSnapshot.docs.map((doc) => doc.data().createdAt)
                .filter((t): t is Timestamp => t !== undefined);

        const applicationCreateAtList = applicationsSnapshot.docs.map((doc) => doc.data().createdAt);
        setApplicationData(applicationCreateAtList);
        setReferrerData(referrerCreateAtList);
        const messageList = messages.map((msg) => msg.timestamp)
                .filter((t): t is Timestamp => t !== undefined);
        setMessageData(messageList);
        const dailyUsers: Record<string, Set<string>> = {};
        messages.forEach(({ sender, timestamp }) => {
          if (!timestamp) return;
          const key = timestamp.toDate().toISOString().split("T")[0];
          if (!dailyUsers[key]) {
            dailyUsers[key] = new Set();
          }
          dailyUsers[key].add(sender);
        });
        const messageUserTimestamps = Object.entries(dailyUsers).flatMap(([date, users]) => Array(users.size).fill(Timestamp.fromDate(new Date(date))));
        setMessageUserData(messageUserTimestamps);
        setDataLoading(false)
      };

      fetchData();
    }
  }, [userIsLoading, isAdmin]);

  if (!isAdmin) {
    return <Navigate to="/companies" replace />;
  }
  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '1000px',
          padding: '16px',
          margin: '0 auto',
        }}
      >
        <Link to="/admin/applications">Applications</Link>
        <Link to="/admin/referrers">Referrers</Link>
        <Link to="/admin/companies">Companies</Link>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gridColumnGap: '16px',
          gridRowGap: '32px',
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '16px',
        }}
      >
        {dataLoading ? <LoadingIndicator /> :
          <>
            <GraphCard
              tableName="Applications"
              inputData={applicationData}
            />
            <GraphCard
              tableName="Referrers"
              inputData={referrerData}
            />
            <GraphCard
              tableName="Message counts"
              inputData={messageData}
            />
            <GraphCard
              tableName="Message users"
              inputData={messageUserData}
            />
          </>
        }
      </Box>
    </Container>
  );
};
